/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-29 14:06:14
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-18 22:24:06
 */
import Vue from 'vue'
import Router from 'vue-router'
import download from '../views/agreement/download'
import doctor from './doctor'
import patient from './patient'
import consultation from './consultation'
import order from './order'
import sys from './sys'
import im from './im'
import education from './education'
import servicePackage from './servicePackage'
import pickUp from './pickUp'
import plan from './plan'
import recipe from './recipe'
import goods from './goods'
import recommend from './recommend'
import agreement from './agreement'
import other from './other'
import meeting from './meeting'
import h5 from './h5'
import wx from './wx'
import faq from './faq'
import pay from './pay'
import conpon from './conpon'
import insurance from './insurance'
import {getToken} from '../utils/auth'

Vue.use(Router)
let routes = [
    {
        path: '/',
        name: 'download',
        component: download
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index'),
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/login/:type',
        name: 'login',
        component: () => import('@/views/login/index'),
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/change/login',
        name: 'changeLogin',
        component: () => import('@/views/login/changeLogin')
    },
    ...doctor,
    ...patient,
    ...consultation,
    ...sys,
    ...order,
    ...im,
    ...education,
    ...servicePackage,
    ...pickUp,
    ...plan,
    ...recipe,
    ...goods,
    ...recommend,
    ...other,
    ...agreement,
    ...wx,
    ...meeting,
    ...h5,
    ...faq,
    ...pay,
    ...insurance,
    ...conpon
]
export default new Router({
    routes
})




// WEBPACK FOOTER //
// ./src/router/index.js